import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import { comics, CATEGORIES, getHotComics, getNewComics, formatViews } from '@/mocks/comics';

export default function Home() {
  const [heroLoaded, setHeroLoaded] = useState(false);

  const hotComics = getHotComics(7);
  const newComics = getNewComics(8);
  const topRated = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 6);

  useEffect(() => {
    setHeroLoaded(true);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20illustration%20with%20warm%20golden%20and%20coral%20tones%2C%20soft%20abstract%20comic%20panel%20background%20with%20gentle%20gradients%2C%20dreamy%20manga%20aesthetic%20with%20subtle%20texture%2C%20warm%20atmospheric%20lighting%2C%20elegant%20composition%2C%20clean%20minimal%20design%20with%20artistic%20brush%20strokes&width=1800&height=900&seq=pudding-hero-bg&orientation=landscape"
            alt="布丁漫画 - 免费在线韩国漫画阅读平台"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
            <div className={`text-center max-w-3xl transition-all duration-700 ${heroLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4">
                布丁漫画
              </h1>
              <p className="text-base md:text-lg text-background-200/90 mb-2 leading-relaxed">
                免费阅读的在线韩国漫画平台
              </p>
              <p className="text-sm md:text-base text-background-300/80 mb-8 leading-relaxed max-w-xl mx-auto">
                官方源更新保证速度与质量，最新最全的韩漫官网，获取一手韩漫资讯的权威站点
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/all"
                  className="px-8 py-3 bg-primary-500 text-background-50 rounded-lg font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  立即阅读
                </Link>
                <Link
                  to="/category/热门"
                  className="px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-lg font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  热门推荐
                </Link>
              </div>

              <div className="flex items-center justify-center gap-6 md:gap-10 mt-10">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-background-50">{comics.length}</div>
                  <div className="text-xs md:text-sm text-background-300/80 mt-1">部精选漫画</div>
                </div>
                <div className="w-px h-10 bg-background-50/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-background-50">{CATEGORIES.length - 1}</div>
                  <div className="text-xs md:text-sm text-background-300/80 mt-1">大分类</div>
                </div>
                <div className="w-px h-10 bg-background-50/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-background-50">100%</div>
                  <div className="text-xs md:text-sm text-background-300/80 mt-1">免费阅读</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Quick Links */}
        <section className="bg-background-50 py-6 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
              {CATEGORIES.map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    cat.key === 'all'
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200 hover:text-foreground-900'
                  }`}
                >
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Comics */}
        <section className="bg-background-50 py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  <i className="ri-fire-line text-accent-500 mr-2"></i>
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">最受欢迎的韩国漫画精选</p>
              </div>
              <Link
                to="/category/all"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-5">
              {hotComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} size="small" showCategory={false} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Updates */}
        <section className="bg-background-100/70 py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  <i className="ri-time-line text-secondary-500 mr-2"></i>
                  最新更新
                </h2>
                <p className="text-sm text-foreground-500 mt-1">刚刚更新的漫画章节</p>
              </div>
              <Link
                to="/category/all"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
              {newComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} size="medium" />
              ))}
            </div>
          </div>
        </section>

        {/* Top Rated */}
        <section className="bg-background-50 py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  <i className="ri-trophy-line text-accent-500 mr-2"></i>
                  高分必看
                </h2>
                <p className="text-sm text-foreground-500 mt-1">评分最高的口碑漫画</p>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
              {topRated.map((comic) => (
                <ComicCard key={comic.id} comic={comic} size="small" showCategory={false} />
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="bg-background-100/70 py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                为什么选择布丁漫画？
              </h2>
              <p className="text-sm text-foreground-500 mt-2">免费阅读的在线韩国漫画平台，最新最全的韩漫官网</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {[
                { icon: 'ri-shield-check-line', title: '官方授权', desc: '所有漫画均来自官方授权渠道，保证内容质量与更新速度' },
                { icon: 'ri-money-cny-circle-line', title: '完全免费', desc: '无需付费，无需会员，随时随地畅享精品韩漫阅读体验' },
                { icon: 'ri-flashlight-line', title: '极速更新', desc: '同步官方更新，第一时间为你带来最新的漫画章节' },
                { icon: 'ri-smartphone-line', title: '多端适配', desc: '支持电脑、平板、手机等多设备阅读，随时随地看漫画' },
              ].map((feature, i) => (
                <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-100 rounded-xl mb-3">
                    <i className={`${feature.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="relative w-full py-16 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20artistic%20Korean%20manhwa%20panel%20background%20with%20soft%20gradients%20in%20coral%20and%20cream%20tones%2C%20gentle%20abstract%20brush%20strokes%2C%20dreamy%20atmospheric%20illustration%2C%20warm%20cozy%20reading%20vibe%2C%20elegant%20minimal%20design%2C%20soft%20texture%20overlay&width=1800&height=600&seq=pudding-cta-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              开启你的韩漫之旅
            </h2>
            <p className="text-sm md:text-base text-background-200/90 mb-6 max-w-lg mx-auto">
              海量精品韩国漫画等你来发现，完全免费，即点即看
            </p>
            <Link
              to="/category/all"
              className="inline-flex px-8 py-3 bg-accent-500 text-background-50 rounded-lg font-medium hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即探索 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
        </section>
      </main>

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '布丁漫画 - 免费阅读的在线韩国漫画 | 最新最全的韩漫官网',
            description: '布丁漫画是最新最全的韩漫官网，提供免费在线韩国漫画阅读，官方源更新保证速度与质量，是获取一手韩漫资讯的权威站点。',
            url: 'https://budingmanhua.com',
            isPartOf: {
              '@type': 'WebSite',
              name: '布丁漫画',
              url: 'https://budingmanhua.com',
            },
          }),
        }}
      />

      <Footer />
    </>
  );
}